// import React, { useEffect, useRef } from 'react'
// import styled from 'styled-components'
// import { Anchor, Link } from '../components/AllSvgs'

// const Container = styled.div`
// position: relative;
// `
// const Slider = styled.div`
// position: fixed;
// top: 0;
// right: 2rem;
// display: flex;
// justify-content: center;
// align-items: center;
// flex-direction: column;
// transform: translateY(-100%);

// .chain{
// transform: rotate(135deg);

// }
//  @media (max-width: 768px) {
//     right: 1rem; /* Adjust positioning for smaller screens */
//   }

// `

// const PreDisplay = styled.div`
// position: absolute;
// top:0;
// right: 2rem;
//  @media (max-width: 768px) {
//     right: 1rem; /* Adjust positioning for smaller screens */
//   }
// `


// const AnchorComponent = (props) => {

//     const ref = useRef(null);
//     const hiddenRef = useRef(null);

//     useEffect(() => {
        
//         const handleScroll = () => {

//             let scrollPosition = window.pageYOffset;
//             let windowSize = window.innerHeight;
//             let bodyHeight = document.body.offsetHeight;
            
//             let diff = Math.max(bodyHeight - (scrollPosition + windowSize) )
//             //diff*100/scrollposition
//             let diffP = (diff * 100) / (bodyHeight - windowSize);

//             ref.current.style.transform = `translateY(${-diffP}%)`

//             if(window.pageYOffset > 5){
//                 hiddenRef.current.style.display = 'none'
//             }else{
//                 hiddenRef.current.style.display = 'block'

//             }
//         }

//         window.addEventListener('scroll', handleScroll)

//         return () =>  window.removeEventListener('scroll', handleScroll)


//     }, [])



//     return (
//         <Container>
//         <PreDisplay ref={hiddenRef} className='hidden'>
    
//         <Anchor width={70} height={70} fill='currentColor'/>
//     </PreDisplay>
//             <Slider ref={ref}>
//                 {
//                     [...Array(props.number)].map((x,id) => {
//                         return <Link key={id} width={25} height={25} fill='currentColor' className="chain" />
//                     })
//                 }
//                 <Anchor width={70} height={70} fill='currentColor'/>
//             </Slider>
//         </Container>
//     )
// }

// export default AnchorComponent
import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { Anchor as AnchorIcon, Link as LinkIcon } from '../components/AllSvgs';

// Styled component for container
const Container = styled.div`
  position: relative;
`;

// Styled component for the slider with media query
const Slider = styled.div`
  position: fixed;
  top: 0;
  right: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  transform: translateY(-100%);

  .chain {
    transform: rotate(135deg);
  }

  @media (max-width: 768px) {
    right: 0.5rem; /* Adjust the position for smaller screens */
  }
`;

// Styled component for the pre-display with media query
const PreDisplay = styled.div`
  position: absolute;
  top: 0;
  right: 2rem;

  @media (max-width: 768px) {
    right: 1rem; /* Adjust the position for smaller screens */
  }
`;

// Styled component for Anchor with media query
const Anchor = styled(AnchorIcon)`
  width: 70px;
  height: 70px;

  @media (max-width: 768px) {
    width: 40px; /* Decrease size for mobile view */
    height: 40px; /* Decrease size for mobile view */
  }
`;

// Styled component for Link with media query
const Link = styled(LinkIcon)`
  width: 20px;
  height: 20px;

  @media (max-width: 768px) {
    width: 20px; /* Decrease size for mobile view */
    height: 20px; /* Decrease size for mobile view */
  }
`;

const AnchorComponent = (props) => {
  const ref = useRef(null);
  const hiddenRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      let scrollPosition = window.pageYOffset;
      let windowSize = window.innerHeight;
      let bodyHeight = document.body.offsetHeight;
      let diff = Math.max(bodyHeight - (scrollPosition + windowSize));
      let diffP = (diff * 100) / (bodyHeight - windowSize);

      ref.current.style.transform = `translateY(${-diffP}%)`;

      if (window.pageYOffset > 5) {
        hiddenRef.current.style.display = 'none';
      } else {
        hiddenRef.current.style.display = 'block';
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <Container>
      <PreDisplay ref={hiddenRef} className='hidden'>
        <Anchor fill='currentColor' />
      </PreDisplay>
      <Slider ref={ref}>
        {
          [...Array(props.number)].map((x, id) => {
            return <Link key={id} fill='currentColor' className="chain" />
          })
        }
        <Anchor fill='currentColor' />
      </Slider>
    </Container>
  );
};

export default AnchorComponent;

